<template>
	<md-card-content>
		<div class="md-layout">
			<div class="md-layout-item md-size-50">
				<md-field class="md-invalid">
					<label>Type d'absence *</label>
					<md-select v-model="absence.idAbsenceType"  name="idAbsenceType" id="idAbsenceType">
						<md-option v-for="absenceType in absenceTypes" :key="absenceType.id" :value="absenceType.id">
							{{ absenceType.name }}
						</md-option>
					</md-select>
					<validation-error :errors="apiValidationErrors.absence_type_id" />
				</md-field>
			</div>
			<div class="md-layout-item md-size-50">
				<md-field class="md-invalid">
					<label>Jour</label>
					<md-select v-model="absence.dayNumber" name="dayNumber" id="dayNumber" :disabled="absence.idAbsenceType !== 1">
						<md-option v-for="(day, index) in days" :key="index" :value="index">
							{{ day }}
						</md-option>
					</md-select>
					<validation-error :errors="apiValidationErrors.day_number" />
				</md-field>
			</div>
		</div>
		<div class="md-layout mt-4">
			<div class="md-layout-item md-size-50">
				<md-field class="md-invalid">
					<label>Technicien *</label>
					<md-select v-model="absence.idTechnician"  name="idTechnician" id="idTechnician">
						<md-option v-for="technician in technicians" :key="technician.id" :value="technician.id">
							{{ technician.full_name }}
						</md-option>
					</md-select>
					<validation-error :errors="apiValidationErrors.technician_id" />
				</md-field>
			</div>
		</div>
		<div class="md-layout mt-4">
			<div class="md-layout-item md-size-50">
				<div class="md-vdatepicker">
					<datetime v-model="absence.start" :type="absence.idAbsenceType === 7 ? 'datetime' : 'date'"
						:phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
						input-class="datetime-placeholder"
					>
						<label slot="before">Début</label>
					</datetime>
					<validation-error :errors="apiValidationErrors.date_start" />
				</div>
			</div>
			<div class="md-layout-item md-size-50">
				<div class="md-vdatepicker">
					<datetime v-model="absence.end" :type="absence.idAbsenceType === 7 ? 'datetime' : 'date'"
						:phrases="{ ok: 'Confirmer', cancel: 'Annuler' }"
						input-class="datetime-placeholder"
					>
						<label slot="before">Fin</label>
					</datetime>
					<validation-error :errors="apiValidationErrors.date_end" />
				</div>
			</div>
		</div>
		<div class="md-layout mt-4">
			<div class="md-layout-item md-size-100">
				<md-field class="md-invalid">
					<label>Commentaire</label>
					<md-textarea v-model="absence.comment" name="comment" md-autogrow></md-textarea>
					<validation-error :errors="apiValidationErrors.comment" />
				</md-field>
			</div>
		</div>
	</md-card-content>
</template>

<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
	name: "AbsenceForm",
	components: {
		ValidationError
	},
	mixins: [formMixin],
	props: {
		absence: Object,
		errors: Array
	},
	data() {
		return {
			absenceTypes: [],
			technicians: [],
			days: []
		}
	},
	methods: {
		async getTechnicians() {
			const { data } = await this.$store.dispatch('users/getTechnicians', {})
			this.technicians = data
		},
		async getAbsenceTypes() {
			const { data } = await this.$store.dispatch('absences/getAbsenceTypes')
			this.absenceTypes = data
		},
		formatWeekdays() {
			let days = []
			this.$moment.weekdays(true).map(day => {
				days.push(day.charAt(0).toUpperCase() + day.slice(1))
			})
			days.pop()
			days.pop()
			this.days = days
		},
		setDateTimePlaceholder() {
			const inputs = document.getElementsByClassName('datetime-placeholder')
			for (const [key, input] of Object.entries(inputs)) {
				input.setAttribute(
					'placeholder',
					this.$moment(new Date()).format('DD MMMM YYYY' + (this.absence.idAbsenceType === 7 ? ' à HH:mm' : ''))
				);
			}
		}
	},
	watch: {
		errors: function (newVal, oldVal) {
			this.resetApiValidation();
			if (newVal) {
				this.setApiValidation(newVal);
			}
		},
		'absence.idAbsenceType': function (newVal) {
			if(newVal !== 1) {
				this.absence.dayNumber = null
			}
			this.setDateTimePlaceholder()
		},
	},
	mounted() {
		this.getTechnicians()
		this.getAbsenceTypes()
		this.formatWeekdays()
		this.setDateTimePlaceholder()
	}
}
</script>

<style scoped>

</style>
